import { RouterConfigOptions, Routes } from '@angular/router';
import { authMatcher } from '@auth/auth.routing';

export const ZefRoutes: Routes = [
  { path: 'plans', loadChildren: () => import('@plans/plans.module').then((m) => m.PlansModule) },

  { matcher: authMatcher, loadChildren: () => import('@auth/auth.module').then((m) => m.AuthModule) },

  // Report preview route within the main application itself

  { path: 'preview', loadChildren: () => import('@report/report.module').then((m) => m.ReportModule) },
  { path: 'report', loadChildren: () => import('@report/report.module').then((m) => m.ReportModule) },

  { path: '', pathMatch: 'prefix', loadChildren: () => import('@home/home.module').then((m) => m.HomeModule) },
];

export const zefRouterConfig: RouterConfigOptions = { paramsInheritanceStrategy: 'always' };
